import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME } from "src/constant/common";
import { useTranslation } from "react-i18next";
import { PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const VehiclePart = ({ errors, register }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <AccordionItem>
      <AccordionHeader targetId="2" className="mt-0 fw-bold">
        {t("new.vehicle.title")}
      </AccordionHeader>
      <AccordionBody accordionId="2">
        <div className="row">
          <div className="col-md-6">
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.LENGTH}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.LENGTH]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`) })}
              unit="m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.DRY_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`) })}
              unit="kg"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.PROPELLANT_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`) })}
              unit="kg"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`) }),
              }}
              unit="x, y, z) (kgm&sup2;"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`) }),
              }}
              unit="x, y, z) (m"
            />
          </div>

          <div className="col-md-6">
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.RADIUS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.RADIUS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`) })}
              unit="m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.ENGINE_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`) })}
              unit="kg"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.NON_PROPELLANT_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`) })}
              unit="kg"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.CENTER_OF_PRESSURE]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`)}
              name={`vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`}
              placeholder={t("new.field_placeholder", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`) })}
              classInput="width-by-percent-80"
              errors={errors?.vehicle?.[FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`) }),
              }}
              unit="x, y, z) (kgm&sup2;"
            />
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default VehiclePart;
